import { otpDelivery } from "../../OptionalFeatures/SecureEcommerceACS";

const ECommerceOverview = ({ data }) => {
  const {
    of_acs_enable_acs,
    of_acs_acs_provider,
    of_acs_provider_other,
    of_acs_otp_services = [],
    of_acs_otp_service_other,
    of_acs_otp_service_provider,
    of_acs_otp_service_provider_other,
  } = data["6_5"];
  return (
    <div className="forms-instance" style={{ color: "#111" }}>
      <div i2c-grid="grid gap-sm" className="">
        <div i2c-grid="12@md" className="review-summary-sub-heading">
          <div className="fw-700 font-bold">
            3D Secure E-Commerce ACS Service
          </div>
          <div className="overview-help-text-for-heading">
            Would you like to enable 3D Secure E-Commerce transactions for your
            BIN?
          </div>
          <div className="overview-val-text">
            {of_acs_enable_acs?.length ? of_acs_enable_acs.toUpperCase() : "-"}
          </div>
        </div>

        {of_acs_enable_acs === "yes" ? (
          <>
            <div i2c-grid="12@md">
              <div className="overview-help-text font-bold">
                ACS Service Provider:
              </div>
              <div className="overview-val-text">
                {of_acs_acs_provider?.length
                  ? of_acs_acs_provider.toUpperCase()
                  : "-"}
              </div>
            </div>
            {of_acs_acs_provider === "other" ? (
              <div i2c-grid="12@md">
                <div className="overview-help-text font-bold">
                  Other Details:
                </div>
                <div className="overview-val-text">
                  {of_acs_provider_other?.length ? of_acs_provider_other : "-"}
                </div>
              </div>
            ) : null}
          </>
        ) : null}

        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            Who will deliver OTP to the cardholder
          </div>
          <div className="overview-val-text">
            {of_acs_otp_service_provider?.length
              ? of_acs_otp_service_provider.toUpperCase()
              : "-"}
          </div>
        </div>
        {of_acs_otp_service_provider === "other" ? (
          <div i2c-grid="12@md">
            <div className="overview-help-text font-bold">Other Details:</div>
            <div className="overview-val-text">
              {of_acs_otp_service_provider_other?.length
                ? of_acs_otp_service_provider_other
                : "-"}
            </div>
          </div>
        ) : null}
        <div i2c-grid="12@md">
          <div className="overview-help-text font-bold">
            How would you like the OTP to be delivered to cardholders:
          </div>
          <div
            className="overview-val-text"
            style={{
              display: "flex",
              gap: "var(--i2c-spacing-3)",
              flexWrap: "wrap",
            }}
          >
            {of_acs_otp_services?.length
              ? otpDelivery.map((source, index) =>
                  of_acs_otp_services?.includes(source.value) ? (
                    <span
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "var(--i2c-spacing-2)",
                      }}
                      key={index}
                    >
                      {source.value === "other" ? (
                        <span>{of_acs_otp_service_other},</span>
                      ) : (
                        <span>{source.label},</span>
                      )}
                    </span>
                  ) : (
                    ""
                  ),
                )
              : "-"}
          </div>
        </div>
      </div>
    </div>
  );
};
export default ECommerceOverview;
